/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PaymentsStatus } from './types';
import { apiClient } from '@/utils/apiClient';

export const fetchPaymentsStatus = createAsyncThunk<
  PaymentsStatus,
  void,
  { rejectValue: string }
>('payments/status/fetch', async (_payload, { rejectWithValue }) => {
  try {
    const res = await apiClient('/payments/api/v1/status/', { method: 'GET' });
    return res as PaymentsStatus;
  } catch (err: any) {
    const r: any = err?.response ?? err;
    const msg =
      (Array.isArray(r?.error) && r.error.join(' ')) ||
      r?.error ||
      r?.message ||
      'Failed to load payment status';
    return rejectWithValue(String(msg));
  }
});
